import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface HubProfileUIState {
  selectedProfileUuid: string | null;
  isSwitchingProfile: boolean;
  setSelectedProfile: (uuid: string | null) => void;
  setIsSwitchingProfile: (switching: boolean) => void;
  clearSwitchingState: () => void;
  reset: () => void;
}

/**
 * The persisted selection lives in HubProfileStorageService (shared with
 * HubRepository and the hub hooks); app/initHubProfileStore.ts hydrates this
 * store from it at boot, before the React tree mounts.
 */
export const useHubProfileStore = create<HubProfileUIState>()(
  devtools(
    (set) => ({
      selectedProfileUuid: null,
      isSwitchingProfile: false,
      setSelectedProfile: (uuid) => set({ selectedProfileUuid: uuid }),
      setIsSwitchingProfile: (switching) => set({ isSwitchingProfile: switching }),
      clearSwitchingState: () => set({ isSwitchingProfile: false }),
      reset: () => set({ selectedProfileUuid: null, isSwitchingProfile: false }),
    }),
    { name: "HubProfileStore" },
  ),
);
